import React, { useState, useEffect, useContext, useRef } from 'react';
import {
	Container,
	Stack,
	AppBar,
	Toolbar,
	Typography,
	Dialog,
	IconButton,
	TableContainer,
	Table,
	TableCell,
	TableRow,
	TableHead,
	TableBody,
	Divider
} from '@mui/material';
import { useParams } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import PrintRoundedIcon from '@mui/icons-material/PrintRounded';
import moment from 'moment';
import { DataContext } from '../../../../context/DataContext';
import { getToken, getUser } from '../../../../api/Account';
import { isEmpty } from 'lodash';
import NoData from '../../../../components/NoData';
import { getNominaByIdAsync } from '../../../../api/Employees';
import { simpleMessage } from '../../../../helpers/Helpers';
import { PrintReport } from '../../../../components/PrintReport';

const PrintNomina = () => {
	const [data, setData] = useState([]);
	const [detail, setDetail] = useState([]);
	const compRef = useRef();
	const { id } = useParams();
	const { setIsLoading, setIsUnautorized, title, slogan, icon } = useContext(DataContext);

	const token = getToken();
	const user = getUser();

	useEffect(() => {
		getData();
	}, []);

	const getData = async () => {
		setIsLoading(true);
		const result = await getNominaByIdAsync(token, id);
		if (!result.statusResponse) {
			setIsLoading(false);
			if (result.error === 'Unauthorized') {
				setIsUnautorized(true);
				return;
			}
			simpleMessage(result.error, 'error');
			return;
		}

		if (result.data.result.estado.id !== 2) {
			simpleMessage('Este periodo aun no esta cerrado', 'error');
			return;
		}
		setData(result.data.result);
		setDetail(result.data.result.detalleNominas);
		setIsLoading(false);
	};

	const pageStyle = `
  @media print {
    html, body {
      height: initial !important;
      overflow: initial !important;
      -webkit-print-color-adjust: exact;
    }
  }
  @media all {
    .pagebreak {
      display: none;
    }
  }
  @media print {
    .pagebreak {
      page-break-before: always;
    }
  }  
  @page { size: landscape;  margin: 4mm; }
`;

	return (
		<div>
			<Dialog fullScreen open={true}>
				<AppBar sx={{ position: 'relative' }}>
					<Toolbar>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
						<Typography
							sx={{ ml: 2, flex: 1, textAlign: 'center' }}
							variant="h5"
							component="div"
						>
							{`${title} `}
						</Typography>
						<img loading="lazy" src={icon} alt="logo" style={{ height: 40 }} />
					</Toolbar>
				</AppBar>

				<Stack display="flex" justifyContent="center">
					<Stack
						direction={'row'}
						justifyContent="space-between"
						paddingLeft={5}
						paddingRight={5}
						marginTop={1}
						marginBottom={1}
					>
						<Stack />

						<Stack>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
							>
								{slogan}
							</Typography>
							<Typography
								sx={{
									color: '#2196f3',
									textAlign: 'center',
									fontWeight: 'bold'
								}}
								variant="h6"
								component="div"
							>
								Nomina de Personal
							</Typography>
							<Typography fontSize={11} textAlign="center">
								{`PERIODO DEL ${moment(data.desde).format('L')} AL ${moment(
									data.hasta
								).format('L')}`}
							</Typography>
						</Stack>

						<ReactToPrint
							trigger={() => {
								return (
									<IconButton variant="outlined">
										<PrintRoundedIcon
											style={{ fontSize: 40, color: '#2979ff', width: 60 }}
										/>
									</IconButton>
								);
							}}
							content={() => compRef.current}
							pageStyle={pageStyle}
						/>
					</Stack>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="flex-end">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								{/* <Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography> */}
							</Stack>
						</Stack>
					</Container>
				</Stack>

				<Container maxWidth={false} sx={{ textAlign: 'center' }}>
					<hr />
					{isEmpty(data) ? (
						<NoData />
					) : (
						<TableContainer>
							<Table aria-label="simple table" size="small">
								<TableHead>
									<TableRow>
										<TableCell colSpan={6} />

										<TableCell
											align="center"
											className=" fw-bold bg-success"
											colSpan={3}
											style={{ fontSize: 11 }}
										>
											INGRESOS
										</TableCell>
										<TableCell
											align="center"
											className=" fw-bold bg-warning"
											colSpan={3}
											style={{ fontSize: 11 }}
										>
											DEDUCCIONES
										</TableCell>
										<TableCell colSpan={4} />
									</TableRow>
									<TableRow>
										<TableCell
											align="left"
											className="text-primary fw-bold "
											style={{ fontSize: 11 }}
										>
											#
										</TableCell>
										<TableCell
											align="left"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Nombre del Trabajador
										</TableCell>
										<TableCell
											align="left"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Cargo
										</TableCell>
										<TableCell
											align="left"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Tipo Gasto
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Salario Mensual
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Salario Quincenal
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											# Horas Extras
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Monto H/E
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Total Ingresos
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Inss Lab. 7%
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											IR Laboral
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Total Deducciones
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Neto a Recibir
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Inss Pat. 21.5%
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											INATEC 2%
										</TableCell>
										<TableCell
											align="center"
											className="text-primary fw-bold"
											style={{ fontSize: 11 }}
										>
											Firma
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{detail.map((d) => {
										const {
											id,
											empleado,
											salario,
											aporteINSS,
											inatec,
											totalPercibir,
											inssPatronal
										} = d;

										return (
											<TableRow key={id}>
												<TableCell
													align="center"
													component="th"
													scope="row"
													style={{ fontSize: 10 }}
												>
													{id}
												</TableCell>
												<TableCell align="left" style={{ fontSize: 10 }}>
													{empleado.inssNumber} - {empleado.fullName}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{empleado.puesto.description}
												</TableCell>
												<TableCell align="left" style={{ fontSize: 10 }}>
													VENTA
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(empleado.salario)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(salario)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													0
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(0)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(salario)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(aporteINSS)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(0)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(aporteINSS)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(totalPercibir)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(inssPatronal)}
												</TableCell>
												<TableCell align="center" style={{ fontSize: 10 }}>
													{new Intl.NumberFormat('es-NI', {
														style: 'currency',
														currency: 'NIO'
													}).format(inatec)}
												</TableCell>
												<TableCell />
											</TableRow>
										);
									})}
								</TableBody>
							</Table>
						</TableContainer>
					)}
				</Container>
			</Dialog>

			<div
				style={{
					display: 'none'
				}}
			>
				<PrintReport
					ref={compRef}
					titulo={'Nomina de Personal'}
					fecha={`Fecha: ${moment().format('L')}`}
				>
					<Typography fontSize={11} textAlign="center">
						{`PERIODO DEL ${moment(data.desde).format('L')} AL ${moment(
							data.hasta
						).format('L')}`}
					</Typography>
					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<Stack direction={'row'} justifyContent="flex-end">
							<Stack>
								<Typography
									sx={{
										color: '#2196f3',
										textAlign: 'left'
									}}
									fontSize={11}
								>
									Usuario:
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{user}
								</Typography>
								<Typography fontSize={11} textAlign="left">
									{`Fecha y Hora: ${moment().format('DD/MM/YYYY hh:mm A')}`}
								</Typography>
							</Stack>
						</Stack>
					</Container>

					<Container maxWidth={false} sx={{ textAlign: 'center' }}>
						<hr />
						{isEmpty(data) ? (
							<NoData />
						) : (
							<TableContainer>
								<Table aria-label="simple table" size="small">
									<TableHead>
										<TableRow>
											<TableCell colSpan={6} />

											<TableCell
												align="center"
												className=" fw-bold bg-success"
												colSpan={3}
												style={{ fontSize: 10 }}
											>
												INGRESOS
											</TableCell>
											<TableCell
												align="center"
												className=" fw-bold bg-warning"
												colSpan={3}
												style={{ fontSize: 10 }}
											>
												DEDUCCIONES
											</TableCell>
											<TableCell colSpan={4} />
										</TableRow>
										<TableRow>
											<TableCell
												align="left"
												className="text-primary fw-bold "
												style={{ fontSize: 10 }}
											>
												#
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Nombre del Trabajador
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Cargo
											</TableCell>
											<TableCell
												align="left"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Tipo Gasto
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Salario Mensual
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Salario Quincenal
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												# Horas Extras
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Monto H/E
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Total Ingresos
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Inss Lab. 7%
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												IR Laboral
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Total Deducciones
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Neto a Recibir
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Inss Pat. 21.5%
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												INATEC 2%
											</TableCell>
											<TableCell
												align="center"
												className="text-primary fw-bold"
												style={{ fontSize: 10 }}
											>
												Firma
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{detail.map((d) => {
											const {
												id,
												empleado,
												salario,
												aporteINSS,
												inatec,
												totalPercibir,
												inssPatronal
											} = d;

											return (
												<TableRow key={id}>
													<TableCell
														align="center"
														component="th"
														scope="row"
														style={{ fontSize: 10 }}
														className="text-dark"
													>
														{id}
													</TableCell>
													<TableCell
														align="left"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{empleado.inssNumber} - {empleado.fullName}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{empleado.puesto.description}
													</TableCell>
													<TableCell
														align="left"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														VENTA
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(empleado.salario)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(salario)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														0
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(0)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(salario)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(aporteINSS)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(0)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(aporteINSS)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(totalPercibir)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(inssPatronal)}
													</TableCell>
													<TableCell
														align="center"
														style={{ fontSize: 9 }}
														className="text-dark"
													>
														{new Intl.NumberFormat('es-NI', {
															style: 'currency',
															currency: 'NIO'
														}).format(inatec)}
													</TableCell>
													<TableCell />
												</TableRow>
											);
										})}
									</TableBody>
								</Table>
							</TableContainer>
						)}
					</Container>
				</PrintReport>
			</div>
		</div>
	);
};

export default PrintNomina;
